import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import DeleteAllowListFormModal from 'src/features/parkingManagement/components/AllowLists/forms/DeleteAllowListFormModal';
import UpdateAllowListFormModal from 'src/features/parkingManagement/components/AllowLists/forms/UpdateAllowListFormModal';
import { allowListMessages } from 'src/features/parkingManagement/utils/allowListMessages';
import { ICON_MAP } from 'src/features/parkingStatus/utils';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipProvider, TooltipTrigger, TooltipContent } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/utils/messages';

import type { AllowList } from 'src/features/parkingManagement/types/allowList';

export default function CellAllowListActions({ row }: CellContext<AllowList, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <UpdateAllowListFormModal
                        semantics={{ entryName: formatMessage(allowListMessages.allowList) }}
                        selectedList={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateAllowListFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteAllowListFormModal
                        selectedList={row.original}
                        semantics={{ entryName: formatMessage(allowListMessages.allowList) }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteAllowListFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
